import React from "react";
import Footer from "components/Footer";

interface Props {
  children: React.ReactNode;
}

const PublicPageShell: React.FC<Props> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default PublicPageShell;
